import { sessionPath } from "../config/GetPagePath";
import { AdminRole, Role } from "../config/Roles";
import { getLocalValue, setToken } from "../utils/auth";

export const handleAdminUsers = param => {
  switch (param) {
    case AdminRole.SUPER_ADMIN:
      return Role.SUPER_ADMIN;
    case AdminRole.IT_MANAGER:
      return Role.IT_MANAGER;
    case AdminRole.CAMPAIGN_MANAGER:
      return Role.CAMPAIGN_MANAGER;
    case AdminRole.SUPPORT_ADMIN:
      return Role.SUPPORT_ADMIN;
    case AdminRole.COE_ADMIN:
      return Role.COE_ADMIN;
    case AdminRole.EXECUTIVE:
      return Role.EXECUTIVE;
    case AdminRole.HR:
      return Role.HR;
    case AdminRole.COORDINATOR:
      return Role.COORDINATOR;
    case AdminRole.CEO:
      return Role.CEO;
    default:
      return param;
  }
};

const shouldShowUserFeedbackForm = data => {
  return (
    data.has_completed_user_feedback === "false" &&
    (data.number_of_completed_sessions >= 5)
  );
};

export const getLoginUrl = (coachingRole, isFirstLogin, has_completed_security_questions) => {
  const userData = {
    created_datetime: getLocalValue("created_datetime"),
    has_completed_user_feedback: getLocalValue("has_completed_user_feedback"),
    number_of_completed_sessions: getLocalValue(
      "number_of_completed_sessions"
    ),
  };

  if (shouldShowUserFeedbackForm(userData)) {
    return "/user-feedback/";
  }

  if (isFirstLogin) {
    return "/settings/changePassword";
  }
  if (!has_completed_security_questions) {
    return "/security-question/setup";
  }
  switch (coachingRole) {
    case Role.IT_MANAGER:
    case Role.SUPER_ADMIN:
    case Role.SUPPORT_ADMIN:
    case Role.COE_ADMIN:
      return "/settings/userManagement";
    case Role.HR:
      return "/warningLetters";
    case Role.EXECUTIVE:
      return "/dashboard";
    default:
      return sessionPath();
  }
};

export const handleLoginSuccess = (data, history) => {
  if (data.first_login_day) {
    localStorage.setItem("first_login_day", data.first_login_day);
  }
  // // use localStorage. if user choose to not remember, use sessionStorage instead.
  // loginForm.remember ? setToken(data.token) : setSessionToken(data.token);

  // token should be available in new tab as well.
  setToken(data.token);

  // check for admin, if admin true, after login page should redirect to user management.
  let isAdmin = false;
  let isHR = false;

  // store all user values in localStorage
  Object.keys(data).forEach(key => {
    if (key !== "token") {
      if (key === "u_coaching_role") {
        const coachingRole = data[key];
        localStorage.setItem("u_coaching_role_db", data[key]);
        isHR = coachingRole === AdminRole.HR;
        isAdmin = [
          AdminRole.IT_MANAGER,
          AdminRole.SUPER_ADMIN,
          AdminRole.SUPPORT_ADMIN,
          AdminRole.COE_ADMIN,
        ].includes(coachingRole);
        data[key] = handleAdminUsers(coachingRole);
      }
      localStorage.setItem(key, data[key]);
    }
  });

  // redirect
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  const isFirstLogin = getLocalValue("first_login") === "1";
  const has_completed_security_questions = getLocalValue("has_completed_security_questions") === "1";
  const url = getLoginUrl(coachingRole, isFirstLogin, has_completed_security_questions);

  window.location.replace(url)
};